import React, { useState, useContext, useEffect } from 'react'
import PatientContext from '../../../context/patientContext';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { BsFillPlusSquareFill, BsPencilSquare } from 'react-icons/bs';
import SynkinesisQuestionGroup from './SynkinesisQuestionGroup';
import ErrorDialogModal from '../modals/ErrorDialogModal';
import DictionaryContext from '../../../context/dictionaryContext'
import UserPrefContext from '../../../context/userPrefContext'
import AuthContext from '../../../context/authContext';
import { useNavigate } from "react-router-dom"
import { useOktaAuth } from '@okta/okta-react'
import Logout from '../../../Logout';
import SynkinesisListModal from './SynkinesisListModal';
import SynkinesisEditModal from './SynkinesisEditModal';

function SynkinesisModal(props) {
    const panelName = 'synkinesis_assessment_panel'
    const visCtx = useContext(PatientContext);
    const dictCtx = useContext(DictionaryContext)
    const userPrefCtx = useContext(UserPrefContext)
    const authCtx = useContext(AuthContext)

    const [show, setShow] = useState(false);
    const [synkinesisMode, setSynkinesisMode] = useState({mode: 'hide', synkinesis: null})

    const [groups, setGroups] = useState([])
    const [sortedQuestions, setSortedQuestions] = useState([])
    const [modalTitle, setModalTitle] = useState('')
    const [synkinesisValues, setSynkinesisValues] = useState({})
    const [errors, setErrors] = useState([])
    const [showError, setShowError] = useState(false);
    const [doLogout, setDoLogout] = useState(false)

    const [updateDeleteCount, setUpdateDeleteCount] = useState(0)



    // console.log("SynkinesisModal props", props);

    useEffect(() => {
        // console.log("props", props)
        if (dictCtx.dict_intake_form.length > 0) {
            const intakeForm = dictCtx.dict_intake_form.find(form => {
                return form.display_name_short === panelName.replace("_panel","")
            })

            if (intakeForm !== undefined) {
                // setIntakeFormId(intakeForm.id)
                // sort questions by sort_position
                const questions = dictCtx.dict_intake_form_question.filter(quest => {
                    return quest.DictIntakeFormQuestion.dict_intake_form_id === intakeForm.id
                })
                
                const comp = (a,b) => {
                    var agrp = (+a.DictIntakeFormQuestion.group_id) * 100 + (+a.DictIntakeFormQuestion.sort_position)
                    var bgrp = (+b.DictIntakeFormQuestion.group_id) * 100 + (+b.DictIntakeFormQuestion.sort_position)
                    return agrp - bgrp
                }
                // const sortedQuestions = questions.sort((a,b) => a.sort_position - b.sort_postion)
                const sortedQs = questions.sort(comp)
                // console.log("Sorted questions", sortedQs)
                setSortedQuestions(sortedQs)

                if (props.mode === 'ipad' && !!props.patient) {
                    // ipad mode - get user name from props.patient
                    setModalTitle(`${intakeForm.display_name} - ${props.patient.last_name}, ${props.patient.first_name}`)
                } else {
                    // "normal mode - take patient details from patient context"
                    setModalTitle(`${intakeForm.display_name} - ${visCtx.pat_last}, ${visCtx.pat_first}`)
                }
                


                // create result object for Synkinesis Assessmentlike {q0:0, q1:0,...}
                // we will use this object to post results
                const fiVals = sortedQs.reduce((accum, element) => {
                    accum[element.DictIntakeFormQuestion.display_name_short] = 0
                    return accum
                }, {})

                // console.log("fiVals", fiVals)
                setSynkinesisValues(fiVals)



                // setFormQuestions(sortedQuestions)

                // get group_ids of questions (only one id per group)
                const groups_c = sortedQs
                    .map((value, index, qs) => (index > 0 && qs[index-1].DictIntakeFormQuestion.group_id === value.DictIntakeFormQuestion.group_id) ? null : value.DictIntakeFormQuestion.group_id)
                    .filter(value => value !== null)

                // console.log("groups",groups_c)
                setGroups(groups_c)
            }

            // ipad mode
            if (!!props.mode && props.mode === 'ipad') {
                setShow(true)
            }
        }
    }, [dictCtx.dict_intake_form.length, visCtx, props.mode, props.patient])


    // const valueChanged = (new_values) => {
    //     // console.log("synkinesisValues", synkinesisValues)
    //     // console.log("Question value changed! new_values:", new_values)
    //     setSynkinesisValues({...new_values})
    // }

    // validate and save changes
    // const handleSave = () => {
    //     // console.log("SynkinesisModal before save", synkinesisValues)

    //     // make sure we have all values set 
    //     const keys = Object.keys(synkinesisValues)

    //     // console.log("synkinesisValues keys", keys)

    //     const errorsArr = keys.filter((key) => {
    //         return synkinesisValues[key] === 0 
    //     })

    //     setErrors(errorsArr)

    //     // console.log("Errors - missing values in questions", errorsArr)

    //     // if errors array is empty then all fields populated; otherwise some are not
    //     if (errorsArr.length === 0) {
    //         // save data
    //         saveSynkinesisAssessment()

    //         if (props.mode === 'main') {
    //             // change last updated time
    //             if (!!props.setLastUpdatedTime) {
    //                 props.setLastUpdatedTime(new Date().getTime())
    //             }
    //             setShow(false)
    //         } else if (props.mode === 'ipad') {
    //             // ipad mode - log out
    //             logout()
    //         }
            
    //     }        
    // }



    // const handleClose = () => {
    //     if (props.mode === 'ipad') {
    //         logout()
    //     } else {
    //         setErrors([])
    //         setShow(false)
    //     }
    // }


    const handleShow = () => {
        setShow(true)
        setSynkinesisMode({mode: 'new', synkinesis: null})
    }

    const handleShowList = () => {
        setSynkinesisMode({mode: 'list', synkinesis: null})
        // setShowList(true)
    }

    // const saveSynkinesisAssessment = async() => {
    //     try {
    //         // console.log("Creating face instruments", JSON.stringify(faceInstrumentValues))
    //         let synkinesisCreateURL = ''
    //         if (props.mode === 'ipad' && !!props.patient) {
    //             // ipad mode - get patient token from props.patient
    //             synkinesisCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/synkinesis_assessments/from_ipad/${props.patient.form_id}/${props.patient.patient_token}`
    //         } else {
    //             // "normal" mode - take patient token from patient context
    //             synkinesisCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/synkinesis_assessments/${visCtx.pat_token}`
    //         }
            
    //         const response = await fetch(synkinesisCreateURL, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${userPrefCtx.bearerToken}`,
    //                 'accept': 'application/json',
    //                 auth: authCtx.authMode,
    //             },
    //             method: "POST",
    //             body: JSON.stringify(synkinesisValues),
    //         })

    //         if (response.status === 200) {
    //             const responseData = await response.json()
    //             console.log("Created Synkinesis Assessment: responseData", responseData)
                

    //         } else {
    //             console.log("Failed to create Synkinesis Assessment", response)
    //             if (!response.ok) {
    //                 throw new Error('Unprocessable Entity: ' + response.statusText);
    //            }
    //         }
    //     } catch (e) {
    //         console.log("Failed to create Synkinesis Assessment", e)
    //         setShowError(true);
    //     }

    // }

    const logout = () => {
        setDoLogout(true)
    }

    const loggedOut = () => {
        setDoLogout(false)
    }


    // child dialog was closed
    const handleClose = () => {
        // console.log("******* handleClose - synkinesisMode", synkinesisMode)
        switch (synkinesisMode.mode) {
            case 'list':
                // close button was clicked in the list mode - change to hide
                // if any of the efaces were updated or deleted let know the parent component to refresh
                // console.log("Closing the list - updateDeleteCount", updateDeleteCount)
                if (updateDeleteCount > 0) {
                    // forceRefreshEFaces()
                    setUpdateDeleteCount(0)
                    props.setLastUpdatedTime(new Date().getTime())
                }
                setSynkinesisMode({mode:'hide', synkinesis:null})
                break;

            case 'new':
                // close/save button was clicked in the new mode - change to hide
                setSynkinesisMode({mode:'hide', synkinesis:null})
                if (props.mode === 'ipad') {
                    logout()
                } else {
                    setErrors([])
                    setShow(false)
                }
                break;
            case 'edit':
                // close/save/delete button was clicked in the list mode - change to list
                setSynkinesisMode({mode:'list', synkinesis:null})
                break;
        } 
    }


    // synkinesis assessment clicked for editing
    const onSelect = (synkinesis) => {
        // console.log("SynkinesisModal: onSelect - synkinesis", synkinesis)
        setSynkinesisMode({mode:'edit', synkinesis: synkinesis})
    }


    const forceRefreshSynkinesises = () => {
        // let know parent component that data has been changed, so it can refresh
        setTimeout(() => {
            // console.log("@@@@@@@@@ calling onUpdate of the parent component")
            props.onUpdate()
        }, 200)
    }


    // this will be called from the Synkinesis List if an assessment was updated or deleted
    // we'll use it to let the paremt component know to update synkinesis view when the list dialog is closed
    const onUpdateOrDelete = () => {
        // setUpdateDeleteCount(updateDeleteCount+1)
        console.log("SynkinesisModal onUpdateOrDelete - calling props.refreshLastUpdatedTime")
        props.refreshLastUpdatedTime()
    }



    // temp func to format questions - should be changed on the server (database)
    const createQuestions = (qs) => {
        const qNames = ["q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8", "q9"]
        let newQs = qs.map(q => {
            if (qNames.findIndex(qn => qn === q.DictIntakeFormQuestion.display_name_short) >= 0) {
                // reformat qs
                return {
                    ...q, DictIntakeFormQuestion: 
                    {...q.DictIntakeFormQuestion, mapped_property: q.DictIntakeFormQuestion.display_name_short, question_type: "select", question_option_values: [1,2,3,4,5]}
                }
            } else if(q.DictIntakeFormQuestion.display_name ==="Sum of Scores I-IX") {
                return {
                    ...q, DictIntakeFormQuestion: 
                    {...q.DictIntakeFormQuestion, display_name_short: "sum_of_scores", question_type: "sum", question_option_values:["q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8", "q9"]}
                }
            } else if(q.DictIntakeFormQuestion.display_name ==="SAQ Total Score") {
                return {
                    ...q, DictIntakeFormQuestion: 
                    {...q.DictIntakeFormQuestion, display_name_short: "saq_total_score", question_type: "saq", question_option_values: "s1x100/45"}
                }
            } else {
                return q;
            }
        })
        return newQs;
    }


    return (
        <>
            {(!!!props.mode  || (!!props.mode && props.mode !== 'ipad')) && 
                <>
                <BsFillPlusSquareFill onClick={handleShow} className="icon-pointer"/>
                <BsPencilSquare onClick={handleShowList} className="icon-pointer"/>
                </>
            }
            <ErrorDialogModal
                setOpen={showError}
                close={() => setShowError(false)}
                componentName="Synkinesis Assessment"
            />
            {synkinesisMode && (synkinesisMode.mode === 'new' || synkinesisMode.mode === 'edit' ) &&
            <SynkinesisEditModal mode={synkinesisMode} 
                    // show={true} 
                    // dictVisit={props.dictVisit} 
                    // dictPanelId={props.dictPanelId} 
                    onClose={handleClose} 
                    // onSaveOrDelete={synkinesisMode.mode === 'new' ? forceRefreshSynkinesises : onUpdateOrDelete}
                    onSaveOrDelete={onUpdateOrDelete}
            />
            }

            {/* <Modal size="fullscreen" show={show} onHide={handleClose} animation={false}
                style={{ visibility: (showError) ? 'hidden' : 'visible' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title><h4>{modalTitle}</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        {groups.map((group_id, index) => 
                            <SynkinesisQuestionGroup 
                                key={index}
                                group_id={group_id}
                                // questions={sortedQuestions.filter(q => q.DictIntakeFormQuestion.group_id === group_id)}
                                questions={createQuestions(sortedQuestions.filter(q => q.DictIntakeFormQuestion.group_id === group_id))}
                                onChange={valueChanged}
                                errors={errors}
                            />
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer className='justify-content-between'>
                    <div className='w-100'>
                        {errors.length > 0 && <span style={{color:'red', fontWeight:'bold'}} className='text-danger font-weight-bold'>All fields must be populated!</span>}
                    </div>
                    
                    <div className="inline-block text-left">
                        <Button className='mx-2' variant="secondary" onClick={handleClose}>
                            {props.mode === 'ipad' ? 'Logout' : 'Close'}
                        </Button>
                    </div>
                    <div className='inline-block text-right'>
                        <Button className='mx-2' variant="primary" onClick={handleSave}>
                            Save Changes
                        </Button>
                    </div>
                    
                </Modal.Footer>
            </Modal> */}

            {synkinesisMode && synkinesisMode.mode === 'list' &&
                <SynkinesisListModal /*show={showList}*/ 
                    show={true} 
                    // columnMapping={JSON.parse(props.dictVisit.dict_table[0].column_name)} 
                    //columnMapping={JSON.parse(dictCtx.dict_table[0].column_name)} 
                    onClose={handleClose} 
                    onSelect={onSelect}
                    onUpdateOrDelete={onUpdateOrDelete}
                    updateDeleteCount={updateDeleteCount}
                    // unUpdateOrDelete={() => {}}
                    // updateDeleteCount={() => {}}
                />
            }

            <Logout doLogout={doLogout} onLoggedOut={loggedOut} /> 
        </>
    )
}

export default SynkinesisModal
